import React, { useState, useEffect, useCallback } from 'react';
import Entity from './commonHooks.entity';
import '../css/myLogs.css';

const Encounter = ({ local_user, encounter, difficulty, clear, date, entities_array, party_info }) => {
    const [entityVisible, setEntityVisible] = useState(false);
    const [partySort, setPartySort] = useState(false);
    const [arr, setArr] = useState([]);

    useEffect(() => {
        setArr(entities_array);
    }, [entities_array]);

    const formatTimestamp = (timestamp) => {
        var a = new Date(timestamp);

        let options = {
            year: "numeric",
            month: "short",
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            timeZone: 'UTC'
        };
        let formatter = new Intl.DateTimeFormat('en-US', options);
        let formattedTime = formatter.format(a);

        return formattedTime;
    };

    const convertToAbbreviation = (number) => {
        const formatter = new Intl.NumberFormat('en', {
            notation: 'compact',
            compactDisplay: 'short',
            maximumSignificantDigits: 3
        });
        
        return formatter.format(number);
    };

    let dps = ''; // Initialize DPS

    // Check if any entity has the same name as local_user
    const localPlayerEntity = entities_array.find(entity => entity.name === local_user);

    if (localPlayerEntity) {
        dps = convertToAbbreviation(localPlayerEntity.dps); // Set DPS if found
    }

    const sortByDps = (a, b) => {
        return b.dps - a.dps;
    };

    const getCleared = () => {
        if (clear === 1) {
            return '';
        } else {
            return '💀';
        }
    };

    const handlePartySort = () => {
        setPartySort(!partySort);
    };

    const actualPartySort = useCallback((x) => {
        if (party_info == null) {
            return x;
        } else {
            let sortedEntities = [];
            let partyCount = 1;

            // Iterate over each party in party_info
            for (const key in party_info) {
                if (party_info.hasOwnProperty(key)) {
                    // Add "Party #" entry before each party
                    sortedEntities.push({class: `Party ${partyCount}`});
                    partyCount++;

                    // Get entities for the current party
                    const partyEntities = party_info[key].map(name => entities_array.find(entity => entity.name === name));
                    // Sort entities by DPS
                    partyEntities.sort(sortByDps);
                    // Add sorted entities to the list
                    sortedEntities.push(...partyEntities);
                }
            }

            return sortedEntities;
        }
    }, [party_info, entities_array]);

    const doPartySort = useCallback(() => {
        let newArr = [...entities_array];
        if (partySort) {
            newArr = actualPartySort(newArr);
        } else {
            newArr = newArr.sort(sortByDps);
        }
        setArr(newArr);
    }, [actualPartySort, partySort, entities_array]);

    useEffect(() => {
        doPartySort();
    }, [doPartySort]);

    const toggleEntityVisibility = () => {
        setEntityVisible(!entityVisible);
    };

    return (
        <>
            <tr onClick={toggleEntityVisibility} className={entityVisible ? 'table-row-connected' : 'table-row'}>
                <td>{encounter} {difficulty ? `[${difficulty}]` : ''} {getCleared()}</td>
                <td>{local_user}</td>
                <td>{dps}</td>
                <td>{formatTimestamp(date)}</td>
            </tr>
            <button className={`entity-row-button ${entityVisible ? 'expanded' : ''}`} onClick={handlePartySort}>Toggle Sort By Party</button>
            <tr className={`entity-row ${entityVisible ? 'expanded' : ''}`}>
                <td colSpan="4" className={`entity-cell ${entityVisible ? 'expanded' : ''}`}>
                    {entityVisible && <Entity entities_array={arr} />}
                </td>
            </tr>
        </>
    );
};

export default Encounter;
